<template>
      <svg
        :width="width"
        :height="height"
        viewBox="0 0 329.27 329"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m194.8 164.77 128.21-128.21c8.3438-8.3398 8.3438-21.824 0-30.164-8.3398-8.3398-21.824-8.3398-30.164 0l-128.21 128.21-128.21-128.21c-8.3438-8.3398-21.824-8.3398-30.164 0-8.3438 8.3398-8.3438 21.824 0 30.164l128.21 128.21-128.21 128.21c-8.3438 8.3398-8.3438 21.824 0 30.164 4.1562 4.1602 9.6211 6.25 15.082 6.25 5.4609 0 10.922-2.0898 15.082-6.25l128.21-128.21 128.21 128.21c4.1602 4.1602 9.6211 6.25 15.082 6.25 5.4609 0 10.922-2.0898 15.082-6.25 8.3438-8.3398 8.3438-21.824 0-30.164z" fill="currentColor"
        />
      </svg>
</template>

<script>
export default {
    name: 'Close2',
    props: {
        width: { type: String, default: "26px" },
        height: { type: String, default: "26px" },
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// Close2.vue?853349b0